import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import "./formsinglelineinput.css";

const FormSingleLineInput = ({
  setInput,
  setPrice,
  price,
  isError,
  title,
  description,
  placeholder,
  handlePriceChange,
}) => {
  console.log("price", price);
  return (
    <div className="form-element">
      <h2 className="prompt">{title}</h2>
      {/* <p className="prompt-desc">{description}</p> */}
      <input
        onChange={(e) => {
          setInput(e.target.value);
          if (e.target.value === "Lisbon") {
            handlePriceChange();
          }
        }}
        placeholder={placeholder}
        className={isError ? "error-border" : undefined}
      />
      {isError && (
        <ErrorMessage message="please complete this field before continuing" />
      )}
    </div>
  );
};

export default FormSingleLineInput;
